import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { useMutation } from "react-query";

export type DeleteDefinitionChangeParamRequest = {
  id: number | string;
};

export type DeleteDefinitionChangeParamResponse = BaseResponse<any>;

async function deleteDefinitionChangeParam(data: DeleteDefinitionChangeParamRequest): Promise<any> {
  try {
    const id1 = data.id;
    return (await axiosInstance.delete(`/DefinitionChangeParam/Delete?id=${id1}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useDeleteDefinitionChangeParam() {
  return useMutation<any, Error, DeleteDefinitionChangeParamRequest>((variables) =>
    deleteDefinitionChangeParam(variables)
  );
}

